export interface BranchesItem {
  id: string;
  name: string;
  country: string;
  archived: boolean;
}

export enum BranchOptionType {
  delete = 'delete',
  archive = 'archive',
  dearchive = 'dearchive',
}
